import { samePageLinkNavigation } from "@/utils/functions/samePageLinkNavigation";
import { Tab } from "@mui/material";

interface LinkTabProps {
  label?: string;
  href?: string;
  selected?: boolean;
}

const LinkTab = (props: LinkTabProps) => {
  return (
    <Tab
      component="a"
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (samePageLinkNavigation(event)) {
          event.preventDefault();
        }
      }}
      aria-current={props.selected && "page"}
      {...props}
    />
  );
};

export default LinkTab;
